import styled from "styled-components";

export const MediaGalleryCardHolderDiv = styled.div`
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  width: var(--width);
  margin: 50px auto 50px;
  justify-content: center;
  position: relative;
  > p {
    color: var(--white);
    font-size: 32px;
  }
  & .my-masonry-grid {
    display: -webkit-box; /* Not needed if autoprefixing */
    display: -ms-flexbox; /* Not needed if autoprefixing */
    display: flex;
    margin-left: -20px; /* gutter size offset */
    width: auto;
  }
  & .my-masonry-grid_column {
    padding-left: 20px; /* gutter size */
    background-clip: padding-box;
    width: 315px !important;
    &:nth-child(1),
    &:nth-child(5) {
      margin-top: 168px;
    }
    &:nth-child(3),
    &:nth-child(7) {
      margin-top: 184px;
    }
    &:nth-child(4),
    &:nth-child(8) {
      margin-top: 115px;
    }
  }

  & .my-masonry-grid_column > div {
    margin-bottom: 20px;
  }
  & div.placeholder {
    height: 295px;
    background-color: var(--red);
  }
  @media (max-width: 767px) {
    & .my-masonry-grid_column {
      &:nth-child(1),
      &:nth-child(5) {
        margin-top: 0;
      }
      &:nth-child(3),
      &:nth-child(7) {
        margin-top: 0;
      }
      &:nth-child(4),
      &:nth-child(8) {
        margin-top: 0;
      }
    }
  }
`;

export const MediaGalleryCard = styled.div`
  width: 295px;
  margin-bottom: 12px;
  img,
  video {
    width: 295px;
    height: auto;
    cursor: zoom-in;
  }
  @media (max-width: 767px) {
    & h5 {
      text-align: center;
    }
  }
`;
